import { render, staticRenderFns } from "./LoyalityRewardsHistory.vue?vue&type=template&id=5138bb2a"
import script from "./LoyalityRewardsHistory.vue?vue&type=script&lang=js"
export * from "./LoyalityRewardsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports